import React from 'react';
import { ISVGType } from './SVGType';

const BlocksIcon = (props: ISVGType) => {
  const { height = 42, width = 42 } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 42 42"
      fill="none"
    >
      <rect opacity="0.3" width="42" height="42" rx="10" fill="#5FCCD3" fillOpacity="0.4" />
      <mask id="mask0_683_5076" style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="9" y="10" width="24" height="24">
        <rect x="9" y="10" width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_683_5076)">
        <path
          d="M20 29.425V22.575L14 19.1V25.95L20 29.425ZM22 29.425L28 25.95V19.1L22 22.575V29.425ZM21 20.85L26.925 17.425L21 14L15.075 17.425L21 20.85ZM13 27.7C12.6833 27.5167 12.4375 27.275 12.2625 26.975C12.0875 26.675 12 26.3417 12 25.975V18.025C12 17.6583 12.0875 17.325 12.2625 17.025C12.4375 16.725 12.6833 16.4833 13 16.3L20 12.275C20.3167 12.0917 20.65 12 21 12C21.35 12 21.6833 12.0917 22 12.275L29 16.3C29.3167 16.4833 29.5625 16.725 29.7375 17.025C29.9125 17.325 30 17.6583 30 18.025V25.975C30 26.3417 29.9125 26.675 29.7375 26.975C29.5625 27.275 29.3167 27.5167 29 27.7L22 31.725C21.6833 31.9083 21.35 32 21 32C20.65 32 20.3167 31.9083 20 31.725L13 27.7Z"
          fill="#58A1A5"
        />
      </g>
    </svg>
  );
};

export default BlocksIcon;
